import {Injectable} from '@angular/core';
import {KeycloakService} from "keycloak-angular";
import {jwtDecode} from "jwt-decode";
import {LoggedUser} from "../interfaces/logged-user";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private readonly keycloakService: KeycloakService) { }

  isUserLoggedIn(): boolean {
    return this.keycloakService.isLoggedIn();
  }

  async getToken(): Promise<string> {
    return await this.keycloakService.getToken();
  }

  getTokenNoAsync(): Promise<string> {
    return this.keycloakService.getToken();
  }

  async getDecodedToken(): Promise<any> {
    const token = await this.getToken();
    return jwtDecode(token);
  }

  async getUserRoles(): Promise<string[]> {
    const decodedToken = await this.getDecodedToken();
    return decodedToken.realm_access?.roles;
  }

  async getUserName(): Promise<string> {
    const decodedToken = await this.getDecodedToken();
    return decodedToken.preferred_username;
  }
  async logout(): Promise<void> {
    await this.keycloakService.logout();
  }

  getLoggedUserSessionStorage(): LoggedUser | null{
    if (!sessionStorage.getItem('loggedUser')) {
      return null;
    }
    return JSON.parse(sessionStorage.getItem('loggedUser')!);
  }

  setLoggedUserOnSessionStorage(token: string){
    sessionStorage.setItem('loggedUser', JSON.stringify(jwtDecode(token)));
  }

  getRoleFromSessionStorage(){
    const loggedUser = this.getLoggedUserSessionStorage();
    return loggedUser?.resource_access?.unimagen?.roles;
  }

  hasAnyRole(roles?: string[]){
    if (!roles || roles.length === 0) {
      return true; // If no roles are specified, assume access is granted
    }
    const loggedRoles = this.getRoleFromSessionStorage();
    if (loggedRoles){
      for (const role of roles){
        if (loggedRoles.includes(role)) {
          return true; // If any of the required roles are found, access is granted
        }
      }
    }
    return false; // If none of the required roles are found, access is denied
  }
}
